import React, { useEffect, useState } from 'react';


const BiFormRow = (props) => {


    if (props.responsive == true) {

        if (props.divider == true) {
            return <div className="row " style={{ padding:"5px"}} ></div>
        }
        else {
            return (

                <div className="row ">
                    {props.children}
                </div>

            );
        }
    } else {
        if (props.divider == true) {
            return (<tr><td style={{ padding: "5px" }}></td></tr>);
        }
        else {
            return (

                <tr>
                    {props.children}
                </tr>

            );
        }
    }
}

export default BiFormRow;

